import styled from 'styled-components/macro';
import { colorCoreBlack700 } from '@yme/tokens/colors';
import { getTextStyles } from '@yme/utils/styles';
export const ContainerWrapper = styled.section `
  background-color: ${colorCoreBlack700};
`;
export const ProductDisclaimerStyled = styled.div `
  ${({ bgColor }) => bgColor && `background-color: ${bgColor};`}

  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
`;
export const Label = styled.span `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  ${({ textColor }) => textColor && `color: ${textColor};`}

  display: inline-block;

  ${({ isRightToLeft }) => isRightToLeft
    ? `
        direction: rtl;
        margin-left: 4px;
      `
    : `
        direction: ltr;
        margin-right: 4px;
      `}
`;
export const Text = styled.span `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  ${({ textColor }) => textColor && `color: ${textColor};`}
  ${({ isRightToLeft }) => (isRightToLeft ? 'direction: rtl;' : 'direction: ltr;')}
`;
